<template>
  <div>
    <b-overlay
      :show="loadTeachers"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="md"
    >
      <div
        class="resetTeachers text-center"
        v-if="subgroupAdvisors.length != 0"
      >
        <b-button variant="danger" @click="resetAdvisors()" size="sm">
          Clear all
        </b-button>
      </div>
      <div class="d-flex mt-3" style="height: 200px">
        <div class="subgroupNames w-50" style="overflow-y: scroll">
          <b-form-checkbox
            size="sm"
            v-for="(subgroup, index) in subgroupsTeachersOptions"
            :key="index"
            v-model="selectedSubgroupAdvisors"
            :value="subgroup.value"
            :disabled="subgroup.disabled"
            @change="getsubgroupAdvisors(subgroup.value)"
          >
            {{ subgroup.text }}
          </b-form-checkbox>
        </div>

        <div
          class="subgroupTeachers w-50"
          v-if="subgroupAdvisors.length != 0"
          style="overflow-y: scroll"
        >
          <div class="users d-flex flex-wrap">
            <p
              v-for="(advisor, index) in subgroupAdvisors"
              :key="index"
              class="bg-success p-2 text-white rounded ml-2"
              style="font-size: 12px"
            >
              {{ advisor.subgroup + ' - ' + advisor.advisor }}
              <span
                class="text-white btn m-0 p-0"
                @click="subgroupAdvisors.splice(index, 1)"
              >
                <i class="far fa-times-circle ml-2"></i>
              </span>
            </p>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  props: ["subgroupsForTeachers", "surveyId", "survey_type"],

  async created() {
    await this.subgroups;
    await this.resetAdvisors();
  },

  data() {
    return {
      loadTeachers: false,
      subgroupsTeachersOptions: this.subgroups,
      selectedSubgroupAdvisors: [],
      subgroupAdvisors: [],
    };
  },

  methods: {
    async prepareSyncAdvisorsPostData() {
      //Variable defined for API
     

      //********** Calling Sync Teachers API **********/
      const syncAdvisors = await this.syncAdvisorsWithFeedbackSurvey();

      //***************API RESPONSE ****************
      //***************SUCCESS RESPONSE ****************
      if (syncAdvisors) {
        this.$toast.success(`Linking department advisors successfully done.`, {
          position: "top",
          duration: 3000,
        });
      }
      //***************ERROR RESPONSE ****************
      if (!syncAdvisors) {
        this.$toast.error(`Linking course teachers failed, Please try again`, {
          position: "top",
          duration: 3000,
        });
      }
    },
    //Syncing Course Teachers with Survey
    async syncAdvisorsWithFeedbackSurvey() {
      let syncUrl = this.$store.getters.getAPIKey.studentFeedbackSurveySyncAdvisors;
      const url = syncUrl.replace("survey_id", this.surveyId);
      let status = null;
      await this.$axios
        .post(url, { subgroup_advisors:this.subgroupAdvisors })
        .then((response) => {
          status = true;
          response;
        })
        .catch((error) => {
          status = false;
          error;
        });
      return status;
    },
    async resetAdvisors() {
      this.subgroupsTeachersOptions = [];
      this.selectedSubgroupAdvisors = [];
      this.subgroupsTeachersOptions = this.subgroupsForTeachers;
      this.subgroupsTeachersOptions.forEach((subgroup) => {
        subgroup.disabled = false;
      });
      this.subgroupAdvisors = [];
    },

    async getsubgroupAdvisors(subgroupId) {
      this.loadTeachers = true;

      const selectedIndex = this.selectedSubgroupAdvisors.findIndex(
        (val) => val === subgroupId
      );
      const optionIndex = this.subgroupsTeachersOptions.findIndex(
        (opt) => opt.value === subgroupId
      );

      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${subgroupId}/withadvisors`;

      try {
        const response = await this.$axios.get(url);
        const subgroupUsers = response.data;

        if (!subgroupUsers.institution_users || subgroupUsers.institution_users.length === 0) {
          this.$toast.warning("No advisors found!", {
            position: "top",
            duration: 3000,
          });
          this.selectedSubgroupAdvisors.splice(selectedIndex, 1);
        } else {
          this.subgroupsTeachersOptions[optionIndex].disabled = true;
          subgroupUsers.institution_users.forEach((advisor) => {
            const exists = this.subgroupAdvisors.some(
              (item) =>
                item.subgroup_id === subgroupUsers.id &&
                item.advisor === advisor.first_name
            );

            if (!exists) {
              this.subgroupAdvisors.push({
                subgroup: subgroupUsers.name,
                subgroup_id: subgroupUsers.id,
                advisor: advisor.first_name,
                institution_user_id: advisor.id,
              });
            }
          });
        }
      } catch (error) {
        this.$toast.error("Failed to load advisors", {
          position: "top",
          duration: 3000,
        });
      }

      this.loadTeachers = false;
    },
  },
};
</script>
